import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import i18n from 'live/services/i18n'
import theme from 'live/services/theme'

type IProps = {
    title: string
    route: string
    historic: HistoricType
    historicFormat: string
}

type HistoricType = {
    createdAt: number
    updatedAt: number
}

const NavBar = ({ title, route, historic, historicFormat }: IProps): JSX.Element => {
    const NavigateRoute = (routeToNav:string)=>{
        window.history.pushState({filters:true}, null, `${routeToNav}`)
        window.history.go()
    }

    return (
        <>
            <StyledNav className="module-navigation">
                <div className="container">
                    <div className="nav-div">
                        <a className="" onClick={()=>NavigateRoute(route)}>
                            <i className="fas fa-arrow-left"></i>
                            <span className="">{`${i18n('Back To')} ${title}`} </span>
                        </a>
                    </div>
                    {historic && (
                        <div className="historic-div">
                            <i>
                                {historic?.createdAt
                                    ? i18n(`Created at `) + `${moment(historic.createdAt).format(historicFormat)}`
                                    : ''}
                            </i>
                            <i> / </i>
                            <i>
                                {historic?.updatedAt
                                    ? i18n('Last edited ') + `${moment(historic.updatedAt).format(historicFormat)}`
                                    : ''}
                            </i>
                        </div>
                    )}
                </div>
            </StyledNav>
        </>
    )
}

const StyledNav = styled.nav`
    && {
        .container {
            display: flex;
            align-items: center;

            > div {
                color: ${theme['auxiliar-typography']};
                font-family: ${theme['font-semibold']};
                font-size: 13px;
                line-height: 16px;
                text-transform: capitalize;
                padding-right: 22px;
            }
            .nav-div {
                flex: 10;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px;

                > a {
                    margin-right: 10px;
                    color: ${theme['auxiliar-typography']};

                    span {
                        margin-left: 10px;
                    }
                }
            }
            .historic-div {
                color: ${theme['gray-700']};
                font-family: ${theme['font-regular']};
                font-size: 12px;
                line-height: 16px;
                text-transform: capitalize;
                padding-right: 22px;
            }
        }
    }
`

export default NavBar
